import React, {useState} from "react";
import {Rnd} from "react-rnd";
import iconClose from "images/ic_close.svg";
import "./index.css";

const PIDOpener = ({handleClose, handleOpenPID}) => {
  const [inputText, setInputText] = useState("");
  const handleInputChange = event => {
    setInputText(event.target.value);
  };
  const handleClick = () => {
    handleOpenPID(inputText);
  };

  return (
    <Rnd
      default={{
        x: 0,
        y: 100,
        width: 500,
        height: 100,
      }}
      cancel=""
      className="PIDOpener"
    >
      <div className="search">
        <input type="text" className="input" value={inputText} onChange={handleInputChange}></input>
        <button className="getPID" onClick={handleClick}>
          GET
        </button>
      </div>
      <img className="close-button" src={iconClose} alt="close" onClick={handleClose} />
    </Rnd>
  );
};

export default PIDOpener;
